import React from 'react';
import styles from './TabNavVertical.module.css';
import {
  HiUser, HiChartBar, HiShieldCheck, HiCurrencyDollar,
  HiClock, HiChatBubbleLeftRight
} from 'react-icons/hi2';
import Button from '../../ui/Button';

const ICONS = {
  Profile: HiUser,
  Stats: HiChartBar,
  Settings: HiShieldCheck,
  Transactions: HiCurrencyDollar,
  History: HiClock,
  Debates: HiChatBubbleLeftRight
};

export default function TabNavVertical({ tabs, active, onSelect, iconOnly }) {
  return (
    <nav className={styles.nav}>
      {tabs.map(tab => {
        const Icon = ICONS[tab];
        return (
          <Button variant={'ghost'}
            key={tab}
            className={`${styles.btn} ${active === tab ? styles.active : ''}`}
            onClick={() => onSelect(tab)}
            title={iconOnly ? tab : ''}
          >
            <Icon className={styles.icon} />
            {!iconOnly && <span>{tab}</span>}
          </Button>
        );
      })}
    </nav>
  );
}
